import React, { useRef, useEffect, useState } from "react";
import "../../../../styles/customize-components/info-popover.css";
import { CrossIcon } from "../../../../images/icons/icons";

const InfoPopover = ({
  isVisible,
  onClose,
  title = "Information",
  data = [],
  position = "bottom",
  customClass = "",
}) => {
  const [bestPosition, setBestPosition] = useState(position);
  const popoverRef = useRef(null);

  const handleClose = (e) => {
    e.stopPropagation();
    onClose();
  };

  const handlePopoverClick = (e) => {
    e.stopPropagation();
  };

  useEffect(() => {
    if (isVisible && popoverRef.current) {
      const popover = popoverRef.current;

      if (customClass === "stuck-trial-popover") {
        popover.style.position = "fixed";
        popover.style.zIndex = "10000";
        popover.style.left = "50%";
        popover.style.top = "50%";
        popover.style.transform = "translate(-50%, -50%)";
        popover.style.display = "block";
        setBestPosition("bottom");
        return;
      }

      const rect = popover.getBoundingClientRect();

      const infoIcons = document.querySelectorAll(".tb-info-icon");
      let closestIcon = null;
      let minDistance = Infinity;

      infoIcons.forEach((icon) => {
        const iconRect = icon.getBoundingClientRect();
        const distance = Math.abs(rect.top - iconRect.bottom);
        if (distance < minDistance) {
          minDistance = distance;
          closestIcon = icon;
        }
      });

      if (closestIcon) {
        const iconRect = closestIcon.getBoundingClientRect();
        const spaceAbove = iconRect.top;
        const spaceBelow = window.innerHeight - iconRect.bottom;

        if (spaceAbove > spaceBelow && spaceAbove > 200) {
          setBestPosition("top");
        } else {
          setBestPosition("bottom");
        }
      }
    }
  }, [isVisible, customClass]);

  if (!isVisible) return null;

  return (
    <div
      className={`info-popover-wrapper ${bestPosition} ${customClass}`}
      ref={popoverRef}
      onClick={handlePopoverClick}
    >
      <div className="info-popover-arrow"></div>
      <div className="info-popover-container">
        <div className="info-popover-header">
          <h4 className="info-popover-title">{title}</h4>
          <button className="info-popover-close" onClick={handleClose}>
            <CrossIcon />
          </button>
        </div>

        <div className="info-popover-content">
          {data?.map((item, index) => (
            <div
              key={index}
              className={`info-popover-row ${item.customValueClass || ""}`}
            >
              <div className="info-popover-label">
                {item.icon && (
                  <span className="info-row-icon">{item?.icon}</span>
                )}
                <span className="info-label-text">{item?.label}</span>
              </div>
              <div
                className={`info-popover-value ${item.customValueClass || ""}`}
              >
                {item?.value || item?.fallback || "-"}
              </div>
            </div>
          ))}
        </div>

        {data?.some((item) => item?.footer) && (
          <div className="info-popover-footer">
            {data?.find((item) => item?.footer)?.footer}
          </div>
        )}
      </div>
    </div>
  );
};

export default InfoPopover;
